// extracted by mini-css-extract-plugin
export default {"info-item":"InfoItem_info-item__HwUS8","info-label":"InfoItem_info-label__OYihw","info-content":"InfoItem_info-content__i0nnj"};